<template>
    <div class="modal-container-cont">
        <div class="modal-container">
            <div class="modal-form-container">
                <div class="title-box">
                    <h2>{{ getString('cadastrar_nova_senha') }}</h2>
                </div>
            </div>

            <div class="form">
                <div class="config-item distance-bottom">
                    <div class="label-container" :class="{ 'disabled-label': !initialControlsEnabled() }">
                        <label for="new-pass-consumer" v-text="getString('consumidor')"></label>
                    </div>
                    <div id="new-pass-consumer" ref="newPassConsumerDiv" class="div-input-android"
                        :class="{ 'active-input': isTheActiveInput('newPassConsumerDiv') }"
                        @click="switchActiveInput('newPassConsumerDiv')">
                    </div>
                </div>

                <div class="config-item distance-bottom">
                    <div class="label-container" :class="{ 'disabled-label': !initialControlsEnabled() }">
                        <label for="new-pass-password" v-text="getString('senha')"></label>
                    </div>
                    <div id="new-pass-password" ref="newPassPasswordDiv" class="div-input-android"
                        :class="{ 'active-input': isTheActiveInput('newPassPasswordDiv') }"
                        @click="switchActiveInput('newPassPasswordDiv')">
                    </div>
                </div>

                <div class="config-item">
                    <div class="label-container" :class="{ 'disabled-label': !initialControlsEnabled() }">
                        <label for="new-pass-repeatPassword" v-text="getString('repita_a_senha')"></label>
                    </div>
                    <div id="new-pass-repeatPassword" ref="newPassRepeatPasswordDiv" class="div-input-android"
                        :class="{ 'active-input': isTheActiveInput('newPassRepeatPasswordDiv') }"
                        @click="switchActiveInput('newPassRepeatPasswordDiv')">
                    </div>
                </div>
            </div>

            <AndroidKeyboard id="android-keyboard" :inputElement="inputElement" :layout="layout"
                :isPasswordField="isPasswordField" @passwordCharacterTyped="passwordCharacterTyped"
                @passwordCharacterErased="passwordCharacterErased" @passwordFieldCleaned="passwordFieldCleaned">
            </AndroidKeyboard>

            <div class="prod-item-footer">
                <template v-if="initialControlsEnabled()">
                    <DefaultButton :text="getString('cancelar')" outlined="true" @defaultBtnClick="closeModal()">
                    </DefaultButton>
                    <DefaultButton :text="getString('confirmar')" @defaultBtnClick="modalConfirm()"></DefaultButton>
                </template>
                <DefaultButton v-else-if="!controlsEnabled && !registeredSuccessfully" :text="getString('aguarde')"
                    disabled="true">
                </DefaultButton>
                <DefaultButton v-else :text="getString('fechar')" @defaultBtnClick="closeModal()"></DefaultButton>
            </div>
        </div>
    </div>
</template>

<script>
import LocaleController from '@/assets/controllers/LocaleController'
import DefaultButton from '@/components/DefaultButton'
import Util from '@/assets/libs/util'
import requestModule from '@/assets/libs/requestModule'
import AndroidKeyboard from '@/components/AndroidKeyboard/AndroidKeyboard'
import keyboardLayout from '@/assets/libs/keyboardLayout'

export default {
    name: 'NewPasswordModal',
    components: {
        DefaultButton,
        AndroidKeyboard
    },
    data () {
        return {
            inputElement: null,
            layout: keyboardLayout.LOGIN_AND_PASSWORD,
            isPasswordField: false,
            input: null,
            consumer: '',
            password: '',
            repeatPassword: '',
            controlsEnabled: true,
            registeredSuccessfully: false
        }
    },
    mounted () {
        this.inputElement = this.$refs.newPassConsumerDiv
    },
    methods: {
        isTheActiveInput: function (divReference) {
            return this.inputElement === this.$refs[divReference]
        },
        switchActiveInput: function (divReference) {
            this.inputElement = this.$refs[divReference]
            this.isPasswordField = this.inputElement === this.$refs.newPassPasswordDiv ||
                this.inputElement === this.$refs.newPassRepeatPasswordDiv
        },
        passwordCharacterTyped: function (key) {
            if (this.inputElement === this.$refs.newPassPasswordDiv) {
                this.password += key
            } else if (this.inputElement === this.$refs.newPassRepeatPasswordDiv) {
                this.repeatPassword += key
            }
        },
        passwordCharacterErased: function () {
            if (this.inputElement === this.$refs.newPassPasswordDiv) {
                this.password = this.password.slice(0, -1)
            } else if (this.inputElement === this.$refs.newPassRepeatPasswordDiv) {
                this.repeatPassword = this.repeatPassword.slice(0, -1)
            }
        },
        passwordFieldCleaned: function () {
            if (this.inputElement === this.$refs.newPassPasswordDiv) {
                this.password = ''
            } else if (this.inputElement === this.$refs.newPassRepeatPasswordDiv) {
                this.repeatPassword = ''
            }
        },
        getString: function (key) {
            return LocaleController.getString(key)
        },
        initialControlsEnabled: function () {
            return this.controlsEnabled && !this.registeredSuccessfully
        },
        closeModal: function () {
            if (this.controlsEnabled) {
                this.$emit('closeNewPasswordModal')
            }
        },
        modalConfirm: function () {
            this.consumer = this.$refs.newPassConsumerDiv.innerText

            let result = this.validateInputs()
            if (result.isValid) {
                this.registerNewPassword()
            } else {
                Util.showInfoModal(result.message)
            }
        },
        disableControls: function () {
            this.controlsEnabled = false
            this.$emit('disableOverlayClick')
            this.visible = false
        },
        enableControls: function () {
            this.controlsEnabled = true
            this.$emit('enableOverlayClick')
        },
        validateInputs: function () {
            let result = {
                isValid: true,
                message: ''
            }

            let anyEmptyField = this.consumer == null || this.consumer === '' || this.password == null ||
                this.password === '' || this.repeatPassword == null || this.repeatPassword === ''

            if (anyEmptyField) {
                result.isValid = false
                result.message = this.getString('todos_campos_obrigatorios')
                return result
            }

            if (this.password !== this.repeatPassword) {
                result.isValid = false
                result.message = this.getString('senhas_nao_sao_iguais')
                return result
            }

            return result
        },
        registerNewPassword: async function () {
            this.disableControls()

            let requestData = {
                consumerId: this.consumer,
                password: this.password
            }

            let response = await requestModule.postRequest('consumer/registerConsumerPass', requestData)
                .then(res => res || {})
                .catch((e) => { })

            let success = response && !response.error && response.data && !Array.isArray(response.data)

            if (success) {
                let message = response.data.message || this.getString('senha_cadastrada_sucesso')
                Util.showInfoModal(message)
                this.enableControls()
                this.closeModal()
            } else {
                let hasErrorMessage = response && response.error && response.message && response.message !== ''
                let message = hasErrorMessage ? response.message : this.getString('nao_possivel_criar_nova_senha')
                Util.showInfoModal(message)
                this.enableControls()
            }
        },
        accept: function (text) {
            this.hide()
        },
        show: function (e) {
            if (!Util.isAndroidMode()) {
                this.input = e.target
                if (!this.visible) {
                    this.visible = true
                }
            }
        },
        hide: function () {
            this.visible = false
        },
        next: function () {
            let inputs = document.querySelectorAll('input')
            let found = false;
            [].forEach.call(inputs, (item, i) => {
                if (!found && item === this.input && i < inputs.length - 1) {
                    found = true
                    this.$nextTick(() => {
                        inputs[i + 1].focus()
                    })
                }
            })
            if (!found) {
                this.input.blur()
                this.hide()
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.modal-container-cont {
    .full;
    pointer-events: none;
    display: block;
    bottom: 0;
    z-index: 5;
}

.modal-container {
    position: absolute;
    pointer-events: auto;
    left: 0;
    right: 0;
    top: 50%;
    margin: auto 75px;
    background: @white;
    border-radius: 25px;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
    transform: translate(0%, -50%);
    height: 100%;

    .modal-form-container {
        position: relative;
        overflow: hidden auto;

        .title-box {
            background-color: @primary-color;
            height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 25px 25px 0px 0px;

            h2 {
                color: @white;
                margin: auto;
                font-size: 40px;
            }
        }
    }

    .form {
        margin: 0px 40px 0px 40px;
        height: 280px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .config-item {
            display: grid;
            grid-template-columns: 40% 60%;
            position: relative;

            label {
                font-size: 30px;
                position: relative;
                display: inline-block;
                top: 50%;
                transform: translate(0, -50%);
                margin: 0;
            }

            .disabled-input {
                pointer-events: none;
                background: rgba(0, 0, 0, 0.1);
                border: 2px solid lightgray;
                color: gray !important;
            }

            .disabled-label {
                pointer-events: none;
            }

            .div-input-android {
                position: relative;
                display: flex;
                align-items: center;
                font-size: 2rem;
                height: 55px;
                background-color: white;
                color: black;
                border: 2px solid @black;
                padding: 0 20px;
            }

            .active-input {
                border: 3px solid @primary-color;
            }
        }

        .distance-bottom {
            margin-bottom: 45px;
        }
    }

    #android-keyboard {
        margin: 30px;
    }

    .balance-information {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 60px;
        max-height: 750px;
        overflow: hidden auto;

        .balance-inner-information {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 60px;
        }

        .total-div {
            margin-bottom: 60px;
        }

        .upper-div {
            margin-bottom: 15px;
        }

        .margin-top {
            margin-top: 15px;
        }

        h2 {
            font-size: 40px;
            color: @primary-color;
            margin-bottom: 60px;
        }

        .balance-text {
            font-size: 30px;
        }

        .balance-value {
            font-size: 40px;
            color: @primary-color;
        }
    }

    .prod-item-footer {
        position: relative;
        display: flex;
        background: rgba(0, 0, 0, 0.1);
        height: 180px;
        border-radius: 0px 0px 25px 25px;

        button {
            position: relative;
            display: block;
            margin: auto;
        }
    }
}

#keyboard {
    .keyboard;
    width: inherit;
    max-width: 930px;
    top: inherit;
    bottom: 0;
    position: unset;
}

@media (max-width: 698px) {

    // Gertec SK210
    .modal-container {
        margin: auto 30px;

        .modal-form-container {
            .title-box {
                height: 50px;

                h2 {
                    font-size: 30px;
                }
            }
        }

        .form {
            margin: 0px 30px 0px 30px;
            height: 220px;

            .config-item {
                grid-template-columns: 30% 70%;

                label {
                    font-size: 15px;
                }

                .div-input-android {
                    font-size: 25px;
                    height: 35px;
                    border: 1px solid @black;
                    padding: 0 10px;
                }

                .active-input {
                    border: 2px solid @primary-color;
                }
            }

            .distance-bottom {
                margin-bottom: 15px;
            }
        }

        #android-keyboard {
            margin: 0;
            .small-screen-keyboard;
            bottom: 30px;
        }

        .prod-item-footer {
            height: 60px;
        }
    }
}

@media (min-width: 699px) and (max-width: 1025px) {

    //@tablet
    .modal-container {
        margin: auto 50px;

        .modal-form-container {
            .title-box {
                height: 100px;

                h2 {
                    font-size: 35px;
                }
            }
        }

        .form {
            margin: 5px 30px 5px 30px;

            .config-item {
                grid-template-columns: 30% 70%;
                label {
                    font-size: 20px;
                }
            }
            .distance-bottom {
                margin-bottom: 25px;
            }
        }

        .balance-information {
            margin-bottom: 30px;
            max-height: 500px;

            .balance-inner-information {
                margin-bottom: 50px;
            }

            .total-div {
                margin-bottom: 40px;
            }

            .upper-div {
                margin-bottom: 10px;
            }

            h2 {
                font-size: 35px;
                margin-bottom: 40px;
            }

            .balance-text {
                font-size: 25px;
            }

            .balance-value {
                font-size: 30px;
            }
        }

        .prod-item-footer {
            height: 130px;
        }

        .android-keyboard {
            margin: 20px;
        }
    }

    #keyboard {
        .keyboard;
        width: inherit;
        position: unset;
        max-width: 760px;
        font-size: 15px;
    }
}

@media (orientation: landscape) {
    .modal-container {
        margin: auto 50px;
        border-radius: 10px;
        .modal-form-container {
            .title-box {
                height: 60px;
                border-radius: 10px 10px 0px 0px;

                h2 {
                    font-size: 35px;
                }
            }
        }

        .form {
            margin: 10px 45px 0px 45px;
            height: auto;
            .config-item {

                label {
                    font-size: 28px;
                }

                .disabled-input {
                    pointer-events: none;
                    background: rgba(0, 0, 0, 0.1);
                    border: 2px solid lightgray;
                    color: gray !important;
                }

                .disabled-label {
                    pointer-events: none;
                }

                .div-input-android {
                    position: relative;
                    display: flex;
                    align-items: center;
                    font-size: 1.8rem;
                    height: 45px;
                    background-color: white;
                    color: black;
                    border: 2px solid @black;
                    padding: 0 10px;
                }

                .active-input {
                    border: 2px solid @primary-color;
                }
            }

            .distance-bottom {
                margin-bottom: 20px;
            }
        }

        #android-keyboard {
            margin: 10px 30px;
        }

        .balance-information {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 60px;
            max-height: 750px;
            overflow: hidden auto;

            .balance-inner-information {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-bottom: 60px;
            }

            .total-div {
                margin-bottom: 60px;
            }

            .upper-div {
                margin-bottom: 15px;
            }

            .margin-top {
                margin-top: 15px;
            }

            h2 {
                font-size: 40px;
                color: @primary-color;
                margin-bottom: 60px;
            }

            .balance-text {
                font-size: 30px;
            }

            .balance-value {
                font-size: 40px;
                color: @primary-color;
            }
        }

        .prod-item-footer {
            position: relative;
            display: flex;
            background: rgba(0, 0, 0, 0.1);
            height: 80px;
            border-radius: 0px 0px 25px 25px;

            button {
                position: relative;
                display: block;
                margin: auto;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/NewPasswordModal.vue